import { render } from "./legoTable.vue?vue&type=template&id=0f8cb2b4"
import script from "./legoTable.vue?vue&type=script&lang=js"
export * from "./legoTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/lego-component/components/element/legoTable/legoTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0f8cb2b4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0f8cb2b4', __exports__)) {
    api.reload('0f8cb2b4', __exports__)
  }
  
  module.hot.accept("./legoTable.vue?vue&type=template&id=0f8cb2b4", () => {
    api.rerender('0f8cb2b4', render)
  })

}


export default __exports__